import {Injectable} from '@angular/core';
import {RoadtripDetail} from '../../core/api/resources/roadtrip-detail.resource';
import {Step} from '../../core/api/resources/step.resource';

@Injectable(
  {providedIn: 'root'}
)
export class StepStateService {
  get hasCommentedTrip(): boolean {
    return this.hasCommentedForTrip;
  }

  set hasCommentedTrip(value: boolean) {
    this.hasCommentedForTrip = value;
  }

  get trip(): RoadtripDetail {
    return this.selectedTrip;
  }

  set trip(value: RoadtripDetail) {
    this.selectedTrip = value;
  }

  get step(): Step {
    return this.selectedStep;
  }

  set step(value: Step) {
    this.selectedStep = value;
  }

  private selectedTrip: RoadtripDetail;
  private selectedStep: Step;
  private hasCommentedForTrip: boolean;
}
